import Image from 'next/image';
import React, { FC } from 'react';
import style from './Card.module.scss';
import { cn } from '@/lib/utils';
import Link from 'next/link';

interface IProps {
  title: string;
  description: string;
  image: string;
  path: string;
}

export const Card: FC<IProps> = ({ title, image, description, path }) => {
  return (
    <div className={cn(style.wrapper, 'bg-white')}>
      <div className={cn(style.iconWrapper)}>
        <Image className={style.image} src={image} alt={title} />
      </div>
      <div className="p-7">
        {' '}
        <p className={cn('mb-4 text-2xl text-black')}>{title}</p>
        <p
          style={{ minHeight: '98px' }}
          className={cn('mb-10 font-normal text-black')}
        >
          {description}
        </p>
        <Link
          href={path}
          className={cn(
            'bg-white',
            'border-black',
            'text-black',
            ' rounded-full border px-5  py-2  text-base'
          )}
        >
          More details
        </Link>
      </div>
    </div>
  );
};
